<div id="app-languages" *ngIf="!isLogged && showLanguageSelector">
  <app-log-in-route *ngIf="showRedirectButton" [route]="url"></app-log-in-route>
  <app-languages></app-languages>
</div>
<router-outlet></router-outlet>
<div id="app-footer" *ngIf="!isLogged && customFooter">
  <app-footer-noauth></app-footer-noauth>
</div>
<iv-loading [hidden]="!loading || isFinishProActive" [color]="'primary'|colors"></iv-loading>
<iv-message #messenger></iv-message>
